<template>
    <div class="container">
        <vue-headful
                title="Events - SIC Dashboard"
        />
        <div class="row">
            <div class="col-md-12 mt-5 mb-2">
                <div class="add-events-text">Add Events For Project Timeline</div>
                <form role="form">
                    <div class="form-group">
                        <!--<label for="sel1">Select Event</label>-->
                        <select class="form-control" id="sel1" name="sellist1" v-model="event_id">
                            <option :disabled="events">Select event</option>
                            <option v-for="(event, index) in events" v-bind:value="event.id" v-bind:key="index">{{event.event_title}}</option>
                        </select>
                    </div>
                    <div class="text-center">
                        <button type="button" @click="addTimelineProject(event_id)" class="btn my-4 btn-primary">
                            <i :class="{'loader': loading}"></i> <span v-if="!loading">Assign Timeline</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 mt-5 mb-5">
                <div class="card shadow">
                    <div class="card-header border-0">
                        <div class="row align-items-center">
                            <div class="col">
                                <h3 class="mb-0">All Project Related Event</h3>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <!-- Projects table -->
                        <table class="table align-items-center table-flush">
                            <thead class="thead-light">
                            <tr>
                                <th>S.No</th>
                                <th>Actions</th>
                                <th scope="col">Event Title</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(pro_event, index) in projectEvents" v-bind:key="index">
                                <td>{{index+1}}</td>
                                <td>
                                    <button @click="deleteProjectEvents(pro_event.events[0].id)" type="button"
                                            class="btn btn-danger fas fa-trash" data-toggle="tooltip"
                                            data-placement="top" title="Delete Event"></button>
                                </td>
                                <td scope="row">
                                    <strong>{{pro_event.events[0].event_title}}</strong>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from "lodash";
import axios from "axios";
import vueHeadful from "vue-headful";

export default {
  data() {
    return {
      projectEvents: {},
      events: {},
      event_id: "",
      loading: false
    };
  },
  methods: {
    get_all_project_events() {
      axios({
        url:
          "admin/projects/events/" +
          this.$route.params.pr_id +
          "?access_token=" +
          localStorage.getItem("access_token"),
        method: "get",
        body: {},
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.projectEvents = result.data.project_events;
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    deleteProjectEvents(event_id) {
      axios({
        method: "delete",
        url:
          "admin/projects/events/delete/" +
          this.$route.params.pr_id +
          "/" +
          event_id,
        data: {
          access_token: localStorage.getItem("access_token")
        },
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.$swal("Event Deleted Successfully", "", "success");
            this.get_all_project_events();
            result;
          },
          error => {
            this.$swal(
              "Error",
              "There was an error. Please try again",
              "error"
            );
            let errors = error.response.data.error;
            for (let error in errors) {
              this.$noty.error("Error: " + _.startCase(errors[error][0]));
            }
          }
        )
        .catch(e => {
          console.log(e);
        });
    },

    get_Events: function() {
      axios({
        url:
          "admin/events?access_token=" + localStorage.getItem("access_token"),
        method: "get",
        body: {},
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.events = result.data.events.data;
            console.log(result);
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    addTimelineProject: function(event_id) {
      let data = {
        access_token: localStorage.getItem("access_token")
      };
      axios({
        method: "POST",
        url:
          "/admin/projects/events/add/" +
          this.$route.params.pr_id +
          "/" +
          event_id,
        data: data,
        headers: {
          "Content-Type": "application/json"
        }
      }).then(
        result => {
          if (result.data.status === true) {
            this.loading = false;
            this.event_id = "";
            this.get_all_project_events();
            this.$swal(
              "Project timeline has been created successfully!",
              "",
              "success"
            );
          }
        },
        error => {
          this.loading = false;
          this.$swal("Something went wrong Please try again!", "", "error");
          error;
        }
      );
    }
  },
  computed: {},
  components: {
    "vue-headful": vueHeadful
  },
  mounted: function() {
    if (this.$route.params.pr_id > 0) {
      this.get_Events();
      this.get_all_project_events();
    }
  }
};
</script>
<style>
</style>
